function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
  id: "reddit-pink-green_svg__snoo-radial-gragient",
  cx: 169.75,
  cy: 92.19,
  fx: 169.75,
  fy: 92.19,
  r: 50.98,
  gradientTransform: "matrix(1 0 0 .87 0 11.64)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#feffff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.4,
  stopColor: "#feffff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.51,
  stopColor: "#f9fcfc"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.62,
  stopColor: "#edf3f5"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.7,
  stopColor: "#dee9ec"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.72,
  stopColor: "#d8e4e8"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.76,
  stopColor: "#ccd8df"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.8,
  stopColor: "#c8d5dd"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.83,
  stopColor: "#ccd6de"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.85,
  stopColor: "#d8dbe2"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.88,
  stopColor: "#ede3e9"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.9,
  stopColor: "#ffebef"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "reddit-pink-green_svg__snoo-radial-gragient-2",
  cx: 47.31,
  fx: 47.31,
  r: 50.98,
  xlinkHref: "#reddit-pink-green_svg__snoo-radial-gragient"
}), /*#__PURE__*/React.createElement("radialGradient", {
  id: "reddit-pink-green_svg__snoo-radial-gragient-3",
  cx: 109.61,
  cy: 85.59,
  fx: 109.61,
  fy: 85.59,
  r: 153.78,
  gradientTransform: "matrix(1 0 0 .7 0 25.56)",
  xlinkHref: "#reddit-pink-green_svg__snoo-radial-gragient"
}), /*#__PURE__*/React.createElement("radialGradient", {
  id: "reddit-pink-green_svg__snoo-radial-gragient-4",
  cx: -6.01,
  cy: 64.68,
  fx: -6.01,
  fy: 64.68,
  r: 12.85,
  gradientTransform: "matrix(1.07 0 0 1.55 81.08 27.26)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#f60"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.5,
  stopColor: "#ff4500"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.7,
  stopColor: "#fc4301"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.82,
  stopColor: "#f43f07"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.92,
  stopColor: "#e53812"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#d4301f"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "reddit-pink-green_svg__snoo-radial-gragient-5",
  cx: -73.55,
  cy: 64.68,
  fx: -73.55,
  fy: 64.68,
  r: 12.85,
  gradientTransform: "matrix(-1.07 0 0 1.55 62.87 27.26)",
  xlinkHref: "#reddit-pink-green_svg__snoo-radial-gragient-4"
}), /*#__PURE__*/React.createElement("radialGradient", {
  id: "reddit-pink-green_svg__snoo-radial-gragient-6",
  cx: 107.93,
  cy: 166.96,
  fx: 107.93,
  fy: 166.96,
  r: 45.3,
  gradientTransform: "matrix(1 0 0 .66 0 57.4)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#172e35"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.29,
  stopColor: "#0e1c21"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.73,
  stopColor: "#030708"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "reddit-pink-green_svg__snoo-radial-gragient-7",
  cx: 147.88,
  cy: 32.94,
  fx: 147.88,
  fy: 32.94,
  r: 39.77,
  gradientTransform: "matrix(1 0 0 .98 0 .54)",
  xlinkHref: "#reddit-pink-green_svg__snoo-radial-gragient"
}), /*#__PURE__*/React.createElement("radialGradient", {
  id: "reddit-pink-green_svg__snoo-radial-gragient-8",
  cx: 131.31,
  cy: 73.08,
  fx: 131.31,
  fy: 73.08,
  r: 32.6,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.48,
  stopColor: "#7a9299"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.67,
  stopColor: "#172e35"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.75
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.82,
  stopColor: "#172e35"
})), /*#__PURE__*/React.createElement("style", null, ".reddit-pink-green_svg__snoo-cls-11,.reddit-pink-green_svg__snoo-cls-9{stroke-width:0;fill:#ffcbd8}"));
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M108 0C48.35 0 0 48.35 0 108c0 29.82 12.09 56.82 31.63 76.37l-20.57 20.57C6.98 209.02 9.87 216 15.64 216H108c59.65 0 108-48.35 108-108S167.65 0 108 0z",
  fill: "#00b06a",
  strokeWidth: 0
});
var _ref3 = /*#__PURE__*/React.createElement("circle", {
  cx: 169.22,
  cy: 106.98,
  r: 25.22,
  strokeWidth: 0,
  fill: "#ffcbd8"
});
var _ref4 = /*#__PURE__*/React.createElement("circle", {
  cx: 46.78,
  cy: 106.98,
  r: 25.22,
  fill: "#ffcbd8",
  strokeWidth: 0
});
var _ref5 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 108.06,
  cy: 128.64,
  rx: 72,
  ry: 54,
  fill: "#ffcbd8",
  strokeWidth: 0
});
var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M86.78 123.48c-.42 9.08-6.49 12.38-13.56 12.38s-12.46-4.93-12.04-14.01c.42-9.08 6.49-15.02 13.56-15.02s12.46 7.58 12.04 16.66zM129.35 123.48c.42 9.08 6.49 12.38 13.56 12.38s12.46-4.93 12.04-14.01c-.42-9.08-6.49-15.02-13.56-15.02s-12.46 7.58-12.04 16.66z",
  fill: "#00b06a",
  strokeWidth: 0
});
var _ref7 = /*#__PURE__*/React.createElement("ellipse", {
  className: "reddit-pink-green_svg__snoo-cls-11",
  cx: 79.63,
  cy: 116.37,
  rx: 2.8,
  ry: 3.05
});
var _ref8 = /*#__PURE__*/React.createElement("ellipse", {
  className: "reddit-pink-green_svg__snoo-cls-11",
  cx: 146.21,
  cy: 116.37,
  rx: 2.8,
  ry: 3.05
});
var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M108.06 142.92c-8.76 0-17.16.43-24.92 1.22-1.33.13-2.17 1.51-1.65 2.74 4.35 10.39 14.61 17.69 26.57 17.69s22.23-7.3 26.57-17.69c.52-1.23-.33-2.61-1.65-2.74-7.77-.79-16.16-1.22-24.92-1.22z",
  fill: "#00b06a",
  strokeWidth: 0
});
var _ref10 = /*#__PURE__*/React.createElement("circle", {
  cx: 147.49,
  cy: 49.43,
  r: 17.87,
  fill: "#ffcbd8",
  strokeWidth: 0
});
var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M107.8 76.92c-2.14 0-3.87-.89-3.87-2.27 0-16.01 13.03-29.04 29.04-29.04 2.14 0 3.87 1.73 3.87 3.87s-1.73 3.87-3.87 3.87c-11.74 0-21.29 9.55-21.29 21.29 0 1.38-1.73 2.27-3.87 2.27z",
  fill: "#ffcbd8",
  strokeWidth: 0
});
var _ref12 = /*#__PURE__*/React.createElement("path", {
  className: "reddit-pink-green_svg__snoo-cls-9",
  d: "M62.82 122.65c.39-8.56 6.08-14.16 12.69-14.16 6.26 0 11.1 6.39 11.28 14.33.17-8.88-5.13-15.99-12.05-15.99s-13.14 6.05-13.56 15.2c-.42 9.15 4.97 13.83 12.04 13.83h.52c-6.44-.16-11.3-4.79-10.91-13.2zM153.3 122.65c-.39-8.56-6.08-14.16-12.69-14.16-6.26 0-11.1 6.39-11.28 14.33-.17-8.88 5.13-15.99 12.05-15.99 7.07 0 13.14 6.05 13.56 15.2.42 9.15-4.97 13.83-12.04 13.83h-.52c6.44-.16 11.3-4.79 10.91-13.2z"
});
function SvgRedditPinkGreen(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 216 216",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12);
}
export default "data:image/svg+xml;base64,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";
export { SvgRedditPinkGreen as ReactComponent };